import { Method } from 'axios';
import { ECountryIso, ELanguage } from '@ringana/configs';
import config from '../../config';
import ApiRoutes from './ApiRoutes';
import { IApiCalendarDoor, IApiGeneralSettings } from '../common/interfaces/api.interface';
import { IChannelizeBroadcast } from '@/common/interfaces/channelize.interface';

const ABAPI_BASEURL = config.announcementbar.url;

export default class ABApiRoutes<TResponse = undefined, TRequestData = undefined, TRequestParams = undefined> extends ApiRoutes<TResponse, TRequestData, TRequestParams> {
  public static getBroadcasts = new ABApiRoutes<IChannelizeBroadcast[]>(`/live/broadcasts`, `get`);
  public static getDoorById = new ABApiRoutes<IApiCalendarDoor, { language: ELanguage }, { id: number; loggedInDeliveryAddressIso?: ECountryIso }>(`/calendar/doors/:id/:loggedInDeliveryAddressIso`, `get`);
  public static getGeneralSettings = new ABApiRoutes<IApiGeneralSettings>(`/general-settings`, `get`);

  private constructor(url: string, method: Method, withCredentials = false) {
    super(url, method, withCredentials, ABAPI_BASEURL);
  }
}
